import {DataObjectId, Hub, noBoardContainerId} from 'yougile-model'
import {Sync} from '@client/sync'
import {UserAccess} from '../../../extensions/user-access'

export const getUserIdsInProjectByBoard = (board?: Hub): DataObjectId[] => {
  if (!board) {
    return []
  }

  const box = Sync.getCurrentSandbox()
  const project = box.getHub(board.location)
  const users = project ? UserAccess.listUsersInProject(project) : []

  return users.map(u => u.id)
}

export const getUserIdsInProjectByTask = (task?: Hub): DataObjectId[] => {
  if (!task) {
    return []
  }

  const box = Sync.getCurrentSandbox()
  if (task.location === noBoardContainerId) {
    return []
  }

  const column = box.getHub(task.location)
  if (!column) {
    return []
  }

  const board = box.getHub(column.location)
  if (!board) {
    return []
  }

  return getUserIdsInProjectByBoard(board)
}
